import React from 'react';

export default function Header(props) {
    return (
        <div className='footer-container'>All content Grace K Beck 2019</div>
    )
};